import { render, staticRenderFns } from "./NewsletterPreferencesForm.vue?vue&type=template&id=6ba6530c&scoped=true&"
import script from "./NewsletterPreferencesForm.vue?vue&type=script&lang=js&"
export * from "./NewsletterPreferencesForm.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterPreferencesForm.vue?vue&type=style&index=0&id=6ba6530c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba6530c",
  null
  
)

export default component.exports